import {createWorker} from '@github-ui/create-worker'
import workerUrl from './taillights.worker?worker&url'

export function createTaillightsWorker() {
  return createWorker(workerUrl, {type: 'module'})
}
